import { createContext, useContext, ReactNode } from "react";

type MobileContextType = {
  isMobile: boolean;
};

const MobileContext = createContext<MobileContextType | undefined>(undefined);

type MobileProviderProps = {
  children: ReactNode;
  isMobile: boolean;
};

export function MobileProvider({ children, isMobile }: MobileProviderProps) {
  return (
    <MobileContext.Provider value={{ isMobile }}>
      {children}
    </MobileContext.Provider>
  );
}

/**
 * Hook to access mobile context
 * @returns {boolean} true if the device is detected as mobile (not tablet)
 * @throws {Error} if used outside of MobileProvider
 */
export function useMobile(): boolean {
  const context = useContext(MobileContext);
  if (context === undefined) {
    throw new Error("useMobile must be used within a MobileProvider");
  }
  return context.isMobile;
}

/**
 * Optional hook that returns undefined if context is not available
 * Useful for components that might render outside the provider
 */
export function useMobileOptional(): boolean | undefined {
  const context = useContext(MobileContext);
  return context?.isMobile;
}
